(() => {
  const q = new URLSearchParams(location.search);
  if (q.get('smooth') === '0') return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches || innerWidth < 1080) return;
  const K = +(q.get('sk') || 6), MULT = +(q.get('sm') || 1), MAXV = +(q.get('smax') || 0);
  const html = document.documentElement; html.classList.add('is-smooth');
  let pos = scrollY, target = scrollY, last = performance.now(), written = scrollY, raf = 0;
  let lockUntil = 0; const LOCKT = +(q.get('mstopt') || 520);
  const maxY = () => Math.max(0, html.scrollHeight - innerHeight);
  const loop = (now) => {
    raf = 0; const dt = Math.min(0.05, (now - last) / 1000); last = now;
    target = Math.min(maxY(), Math.max(0, target));
    let d = target - pos;
    if (Math.abs(d) < 0.5) { pos = target; } else {
      let step = d * (1 - Math.exp(-dt * K));
      if (MAXV > 0) step = Math.max(-MAXV, Math.min(MAXV, step));
      pos += step; raf = requestAnimationFrame(loop);
    }
    written = Math.round(pos); if (Math.round(scrollY) !== written) scrollTo({ top: written, left: 0, behavior: 'instant' });
    window.__e35SmoothV = (target - pos);
  };
  const kick = () => { if (!raf) { last = performance.now(); raf = requestAnimationFrame(loop); } };
  addEventListener('wheel', (e) => {
    if (e.ctrlKey || e.defaultPrevented) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    let el = e.target; while (el && el !== html) { if (el.closest && el.hasAttribute('data-smooth-skip')) return; const st = el.nodeType === 1 && getComputedStyle(el); if (st && /(auto|scroll)/.test(st.overflowY) && el.scrollHeight > el.clientHeight + 1) return; el = el.parentNode; }
    let dy = e.deltaY; if (e.deltaMode === 1) dy *= 40; else if (e.deltaMode === 2) dy *= innerHeight;
    e.preventDefault();
    if (!raf) { pos = scrollY; target = scrollY; }
    const now = performance.now(); if (now < lockUntil) return;
    const S = window.__e35MStops ? window.__e35MStops() : null;
    if (S) { const from = target, to = target + dy * MULT; for (const b of S) { let t = -1; if (from < b && to >= b) t = b + 40; else if (from > b && to <= b) t = b - 40; if (t >= 0) { target = t; lockUntil = now + LOCKT; kick(); return; } } }
    target += dy * MULT; kick();
  }, { passive: false });
  addEventListener('scroll', () => { if (Math.abs(scrollY - written) > 1) { pos = target = scrollY; written = scrollY; } }, { passive: true });
  addEventListener('resize', () => { target = Math.min(maxY(), target); });
  window.__e35Smooth = { get pos() { return pos; }, get target() { return target; }, K, MULT };
})();
